<template>
  <v-list-item class="px-0 py-3 d-flex flex-column">
    <v-list-item-title class="insights-filter-title">{{ $t('insights.filters.date')}}</v-list-item-title>
    <v-row class="pb-1 pt-3 full-width">
      <v-col class="px-0">
        <v-menu
        v-model="dateFromMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
        >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateFrom"
            :label="$t('insights.filters.dateFromLabel')"
            prepend-icon="mdi-calendar"
            readonly
            dense
            clearable
            hide-details
            outlined
            class="insights-filter-input-text full-width"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
        v-model="dateFrom"
        ></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
  <v-row class="full-width">
    <v-col class="px-0">
      <v-menu
      v-model="dateToMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
      >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
        v-model="dateTo"
        :label="$t('insights.filters.dateToLabel')"
        prepend-icon="mdi-calendar"
        readonly
        dense
        clearable
        hide-details
        outlined
        class="insights-filter-input-text full-width"
        v-bind="attrs"
        v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
      v-model="dateTo"
      ></v-date-picker>
    </v-menu>
  </v-col>
</v-row>
</v-list-item>
</template>

<script>
export default {
  name: 'DateRangeFilter',
  data () {
    return {
      dateFromMenu: false,
      dateToMenu: false
    }
  },
  emits: ['fromInput', 'toInput'],
  props: {
    from: {
      type: String
    },
    to: {
      type: String
    }
  },
  computed: {
    dateFrom: {
      get () {
        return this.from
      },
      set (value) {
        this.dateFromMenu = false
        this.$emit('fromInput', value)
      }
    },
    dateTo: {
      get () {
        return this.to
      },
      set (value) {
        this.dateToMenu = false
        this.$emit('toInput', value)
      }
    }
  }
}
</script>

<style>
</style>
